import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Users, Plus } from 'lucide-react';
import InstructorList from './instructors/InstructorList';
import SendInvitation from '../UserManagement/SendInvitation';
import { invitationAPI } from '../../services/api';
import '../../styles/unified.css';

const Instructors = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [activeTab, setActiveTab] = useState('active');
  const [showInvitationForm, setShowInvitationForm] = useState(false);

  const statusTabs = [
    { key: 'active', label: 'Active', color: '#10b981' },
    { key: 'invited', label: 'Invited', color: '#21dc14ff' },
    { key: 'inactive', label: 'Inactive', color: '#6b7280' },
    { key: 'suspended', label: 'Suspended', color: '#ef4444' }
  ];

  const handleNewInstructor = () => {
    setShowInvitationForm(true);
  };

  const handleCloseForm = () => {
    setShowInvitationForm(false);
    // Refresh instructor list to show "Invited" status
  };

  const handleSendInvitation = async (invitationData) => {
    console.log('Sending instructor invitation:', invitationData);
    
    // Add invitationType to distinguish instructor invitations
    const instructorInvitation = {
      ...invitationData,
      invitationType: 'instructor'  // Mark as instructor invitation
    };
    
    // Call API to send invitation
    const response = await invitationAPI.sendInvitation(
      instructorInvitation, 
      getAccessTokenSilently
    );
    
    console.log('Instructor invitation sent successfully:', response);
    
    // Success message is now handled in the modal
    // Modal will close automatically after showing success
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-header-left">
          <Users size={32} className="page-icon" />
          <h1 className="page-title">Instructors</h1>
        </div>
        <button onClick={handleNewInstructor} className="btn-new">
          <Plus size={20} />
          New Instructor
        </button>
      </div>

      {/* Status Tabs */}
      <div className="status-tabs">
        {statusTabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`status-tab ${activeTab === tab.key ? 'active' : ''}`}
            style={{
              '--tab-color': tab.color,
              borderBottomColor: activeTab === tab.key ? tab.color : 'transparent'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="page-content">
        {showInvitationForm ? (
          <SendInvitation
            captureContact
            entityLabel="Instructor"
            onClose={handleCloseForm}
            onSend={handleSendInvitation}
          />
        ) : (
          <InstructorList status={activeTab} />
        )}
      </div>
    </div>
  );
};

export default Instructors;